<template>
  <UIModal
    class="ModalDeleteChat"
    size="lg"
    @close="emit('close')"
    @enter="emit('close')"
  >
    <template #title>
      <slot name="title">Are you sure you want to delete this chat?</slot>
    </template>

    <template #content>
      <slot name="content">
        Deleting this chat will permanently remove all messages from this
        conversation. You will no longer be able to access this chat history.
        <br />
        <br />
        Please note that this action cannot be undone.
      </slot>
    </template>

    <template #actions>
      <slot name="actions">
        <UIButton theme="secondary" @click.prevent="emit('close')">
          Cancel
        </UIButton>
        <UIButton
          :isLoading="isLoading"
          theme="error"
          @click.prevent="emit('confirm')"
        >
          Delete
        </UIButton>
      </slot>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { UIButton, UIModal } from '@foundever/ui-lib'

const emit = defineEmits(['close', 'confirm'])
withDefaults(
  defineProps<{
    isLoading?: boolean
  }>(),
  {
    isLoading: false,
  },
)
</script>

<style scoped lang="scss">
.ModalDeleteChat {
}
</style>
